// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section .description[data-v-adb1db6a]{text-align:center;width:100%}@media only screen and (min-width:1264px){.section .description[data-v-adb1db6a]{width:70%}}.section .loading[data-v-adb1db6a]{display:flex;justify-content:center;margin-bottom:1rem;margin-top:1rem;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
